import { Link } from 'react-router-dom';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';

import { ExternalUrlProps, InternalUrlProps } from './menuPosition.types';

const commonStyle: FlattenSimpleInterpolation = css`
  font-weight: ${FontWeight.Bold};
  font-size: 12px;
  line-height: 16px;
  color: ${Color.Black};
  display: block;
`;

export const ExternalUrl: StyledComponent<'a', ExternalUrlProps> = styled.a<ExternalUrlProps>`
  ${commonStyle}
  pointer-events: ${({ $disabled }: ExternalUrlProps): string => $disabled ? 'none' : 'initial'};
`;

export const InternalUrl: StyledComponent<typeof Link, InternalUrlProps> = styled(Link)<InternalUrlProps>`
  ${commonStyle}
  pointer-events: ${({ $disabled }: InternalUrlProps): string => $disabled ? 'none' : 'initial'};
`;

export const StaticPosition: StyledComponent<'button'> = styled.button`
  ${commonStyle}
`;
